module.exports = __webpack_public_path__ + "static/img/12.d3a3ca2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/12.png
// module id = ParH
// module chunks = 4